import { __decorate, __metadata } from "tslib";
import { SerializableMember, SerializableObject } from '@openhps/core';
import { dcterms, SerializableNamedNode, SerializableThing } from '@openhps/rdf';
import { ldes, tree } from '../../terms';
import { Node } from '../tree';
let EventStream = class EventStream extends SerializableThing {
    constructor() {
        super(...arguments);
        this.timestampPath = new SerializableNamedNode(dcterms.created);
        this.versionOfPath = new SerializableNamedNode(dcterms.isVersionOf);
    }
    /**
     * Set the timestamp path
     * @param {IriString} path Timestamp path (predicate)
     */
    setTimestampPath(path) {
        this.timestampPath = new SerializableNamedNode(path);
    }
    /**
     * Set the version path
     * @param {IriString} path Version path (predicate)
     */
    setVersionOfPath(path) {
        this.versionOfPath = new SerializableNamedNode(path);
    }
};
__decorate([
    SerializableMember({
        rdf: {
            predicate: ldes.timestampPath,
        },
    }),
    __metadata("design:type", SerializableNamedNode)
], EventStream.prototype, "timestampPath", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: ldes.versionOfPath,
        },
    }),
    __metadata("design:type", SerializableNamedNode)
], EventStream.prototype, "versionOfPath", void 0);
__decorate([
    SerializableMember({
        rdf: {
            predicate: tree.view,
            serializer: false,
        },
    }),
    __metadata("design:type", Node)
], EventStream.prototype, "view", void 0);
EventStream = __decorate([
    SerializableObject({
        rdf: {
            type: ldes.EventStream,
        },
    })
], EventStream);
export { EventStream };
//# sourceMappingURL=EventStream.js.map